import React from 'react';
import { alpha, FormControlLabel } from '@mui/material';
import { Field } from 'react-final-form';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const StyledSwitch = styled(Switch)(({}) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: 'var(--marketplaceColor)',
    '&:hover': {
      backgroundColor: alpha('#7748d5', 0.2),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: 'var(--marketplaceColor)',
  },
}));

const FieldBoolean = props => {
  return (
    <div>
      <Field {...props} type={'checkbox'}>
        {({ input }) => (
          <FormControlLabel
            control={<StyledSwitch checked={!!input.value} onChange={input.onChange} {...input} />}
          />
        )}
      </Field>
    </div>
  );
};

export default FieldBoolean;
